import {
    Box, Divider, Typography, Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    CircularProgress,
} from '@mui/material'
import apiClient from '../../utils/apiClient'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

const DisplayDeliveryRange = () => {
    const [deliveryRange, setDeliveryRange] = useState([])
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const getDeliveryRange = async () => {
        try {
            setLoading(true)
            const response = await apiClient.get('/deliveryrange/deliveryrange');
            if (response?.data?.status === true) {
                setDeliveryRange(response?.data?.deliveryFee)
            }

        } catch (error) {
            setError(error?.response?.data?.message || ' Error fetching delivery range')
        }
        finally {
            setLoading(false)
        }
    }
    const handleEditClick = (deliveryRange) => {
        navigate('/create-edit-deliveryrange', { state: { deliveryRange } })
    }

    useEffect(() => {
        getDeliveryRange()
    }, [])

    return (
        <>
            <Box sx={{ backgroundColor: '', padding: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h3">Delivery Range</Typography>
                </Box>
                <Divider sx={{ marginBottom: 3 }} />

                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <TableContainer component={Paper} elevation={1}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Fee</strong></TableCell>
                                    <TableCell><strong>From Km</strong></TableCell>
                                    <TableCell><strong>To Km</strong></TableCell>
                                    <TableCell><strong>Is Active</strong></TableCell>
                                    <TableCell align="right"><strong>Actions</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {deliveryRange.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            No deliveryRange found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    deliveryRange.map((item) => (
                                        <TableRow key={item.id}>

                                            <TableCell>
                                                {item?.fee}
                                            </TableCell>

                                            <TableCell>{item.fromKm}</TableCell>
                                            <TableCell>{item.toKm}</TableCell>
                                            <TableCell>{item?.isActive === true ? 'true' : 'false'}</TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                                                    <IconButton onClick={() => handleEditClick(item)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                    
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {error && <Typography variant="body2" color="error">{error}</Typography>}
            </Box>
        </>
    )
}

export default DisplayDeliveryRange